import untypedCustomerPermissions from "./customer-permissions-list.json";

export interface CustomerPermission {
  id: string;
  description: string;
  tooltip: string;
}

export type CustomerPermissionName = keyof typeof untypedCustomerPermissions.customerPermissions;
export const customerPermissions = Object.freeze(untypedCustomerPermissions.customerPermissions) as Record<CustomerPermissionName, CustomerPermission>;

export type ToolsAndEnablersPermissionName = keyof typeof untypedCustomerPermissions.toolsAndEnablers;
export const toolsAndEnablers = Object.freeze(untypedCustomerPermissions.toolsAndEnablers) as Record<ToolsAndEnablersPermissionName, CustomerPermission>

export type OrderPermissionName = keyof typeof untypedCustomerPermissions.orderPermissions;
export const orderPermissions = Object.freeze(untypedCustomerPermissions.orderPermissions) as Record<OrderPermissionName, CustomerPermission>;

export type ServiceCatalogPermissionName = keyof typeof untypedCustomerPermissions.serviceCatalogPermissions;
export const serviceCatalogPermissions = Object.freeze(untypedCustomerPermissions.serviceCatalogPermissions) as Record<ServiceCatalogPermissionName, CustomerPermission>;

export type HardwareBreakFixPermissionName = keyof typeof untypedCustomerPermissions.hardwareBreakFixPermissions;
export const hardwareBreakFixPermissions = Object.freeze(untypedCustomerPermissions.hardwareBreakFixPermissions) as Record<HardwareBreakFixPermissionName, CustomerPermission>;

export type SoftwareSupportPermissionName = keyof typeof untypedCustomerPermissions.softwareSupportPermissions;
export const softwareSupportPermissions = Object.freeze(untypedCustomerPermissions.softwareSupportPermissions) as Record<SoftwareSupportPermissionName, CustomerPermission>;

export type ServiceRequestPermissionName = keyof typeof untypedCustomerPermissions.serviceRequestPermissions;
export const serviceRequestPermissions = Object.freeze(untypedCustomerPermissions.serviceRequestPermissions) as Record<ServiceRequestPermissionName, CustomerPermission>;

export type ExplorePermissionName = keyof typeof untypedCustomerPermissions.explorePermissions;
export const explorePermissions = Object.freeze(untypedCustomerPermissions.explorePermissions) as Record<ExplorePermissionName, CustomerPermission>;
